const LINK_PROTOCOLS = ['http:', 'https:', 'mailto:', 'tel:']

// 相対URLを解釈するための仮の基準URL（スキームの判定だけに使う）
const RELATIVE_BASE = 'https://relative.invalid/'

/**
 * リンク・iframe に渡すURLのうち、許可したスキーム（既定は http・https・mailto・tel）と相対URLだけを返す。
 * javascript: などはブラウザと同じ規則（前後の空白・タブ・改行を無視し、大文字小文字を区別しない）で判定して undefined にする。
 */
export function toSafeUrl(
  url: string | null | undefined,
  protocols: readonly string[] = LINK_PROTOCOLS
): string | undefined {
  if (!url) {
    return undefined
  }
  try {
    const { protocol } = new URL(url, RELATIVE_BASE)
    return protocols.includes(protocol) ? url : undefined
  } catch {
    return undefined
  }
}
